import Vue from 'vue';
import config from '@/config';

const dominio = {
    vtr: config.dominios.vtr,
    vtr_cloud: config.dominios.vtr_cloud,
    sv: config.dominios.sv,
    sv_cloud: config.dominios.sv_cloud,
    kepler: config.dominios.kepler,
    kepler_cloud: config.dominios.kepler_cloud
}
const errorBilling = config.errorBilling;
const notDue = config.notDue;

const redes = {
    facebook: config.redes.facebook,
    twitter: config.redes.twitter,
    youtube: config.redes.youtube
}

const recaptcha = {
    siteKey: '6LeouLMaAAAAAKIZTFmk86vYrvZ7qngulfnsa9FE',
    formulario: 'billingAccount'
}

const customer = {
        customerIdentificationNumber: { val: 'RUT', sort: 1 },
    }
    /** Invoice success objects. Please keep sort attribute for the table */
const invoice = {
    transactionDate: { val: "Fecha de pago", filter: "date", sort: 2 },
    paymentTypeDescription: { val: "Tipo de pago", filter: "paymentTypeDescription", sort: 3 },
    paymentType: { val: "Tipo de venta", filter: "paymentType", sort: 4 },
    dues: { val: "Número de cuotas", sort: 5 },
    dueAmount: { val: "Valor cuota", filter: "clp", sort: 6 },
    authorizationCode: { val: "Cod. autorización", sort: 7 },
    amount: { val: "Monto pagado", filter: "clp", sort: 12 }
}
const info = {
    buyOrder: { val: "Orden de compra", sort: 8 },
    numeroOperacion: { val: "N° transacción VTR", sort: 10 },
    paymentMethod: { val: "Proveedor de pago", sort: 11 }
}
const accounts = {
        id: { val: "N° de cuenta", sort: 9 }
    }
    /** end of invoice object */

const errorInvoice = {
    date: { val: "Fecha", filter: "date", sort: 2 },
    buyOrder: { val: "Orden de compra", sort: 3 },
    paymentMethod: { val: "Proveedor de pago", sort: 4 }
}

const homeUrl = {
    vtr_com: config.url.comHome,
    sucursal_virtual: config.url.svHome,
    apps: config.url.appHome,
    baf: config.url.comHome
}
const ARBOL = {
    production: {
        vtr_com: {
            normal: {},
            cloud: {}
        },
        sucursal_virtual: {
            normal: {},
            cloud: {}
        }
    },
    qa: {
        vtr_com: {
            normal: {},
            cloud: {}
        },
        sucursal_virtual: {
            normal: {},
            cloud: {}
        }
    },
    development: {
        vtr_com: {
            normal: {},
            cloud: {}
        },
        sucursal_virtual: {
            normal: {},
            cloud: {}
        }
    }
}
const varsFooterHeader = {
    production: {
        vtr_com: {
            normal: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: window.location.origin,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: window.location.origin,
                    text: "Ir a VTR.com"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: "https://vtr.com/condiciones-uso"
                    },
                    privacidad: {
                        url: "https://vtr.com/politica-privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: window.location.origin,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            },
            cloud: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: window.location.origin,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: window.location.origin,
                    text: "Ir a VTR.com"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: "https://vtr.com/condiciones-uso"
                    },
                    privacidad: {
                        url: "https://vtr.com/politica-privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: window.location.origin,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            }
        },
        sucursal_virtual: {
            normal: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.sv,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.sv,
                    text: "Ir al Home"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.vtr + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.vtr + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.sv,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            },
            cloud: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.sv_cloud,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.sv_cloud,
                    text: "Ir al Home"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.vtr_cloud + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.vtr_cloud + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.sv_cloud,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            }
        }
    },
    qa: {
        vtr_com: {
            normal: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: window.location.origin,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: window.location.origin,
                    text: "Ir a VTR.com"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: "https://vtr.com/condiciones-uso"
                    },
                    privacidad: {
                        url: "https://vtr.com/politica-privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: window.location.origin,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            },
            cloud: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: window.location.origin,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: window.location.origin,
                    text: "Ir a VTR.com"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: "https://vtr.com/condiciones-uso"
                    },
                    privacidad: {
                        url: "https://vtr.com/politica-privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: window.location.origin,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            }
        },
        sucursal_virtual: {
            normal: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.kepler + "sucursalvirtual/index.html#/resumen",
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.kepler + "sucursalvirtual/index.html#/resumen",
                    text: "Ir al Home"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.kepler + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.kepler + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.kepler + "sucursalvirtual/index.html#/resumen",
                        text: "VTR Comunicaciones SPA"
                    }
                }
            },
            cloud: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.kepler_cloud + "sucursalvirtual/index.html#/resumen",
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.kepler_cloud + "sucursalvirtual/index.html#/resumen",
                    text: "Ir al Home"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.kepler_cloud + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.kepler_cloud + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.kepler_cloud + "sucursalvirtual/index.html#/resumen",
                        text: "VTR Comunicaciones SPA"
                    }
                }
            }
        }
    },
    development: {
        vtr_com: {
            normal: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.vtr,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.vtr,
                    text: "Ir a VTR.com"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.vtr + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.vtr + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.vtr,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            },
            cloud: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.vtr_cloud,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.vtr_cloud,
                    text: "Ir a VTR.com"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.vtr_cloud + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.vtr_cloud + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.vtr_cloud,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            }
        },
        sucursal_virtual: {
            normal: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.sv,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.sv,
                    text: "Ir al Home"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.vtr + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.vtr + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.sv,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            },
            cloud: {
                centrodeayudaonline: {
                    url: "http://centrodeayudaonline.vtr.com/",
                    text: "Centro de ayuda VTR"
                },
                informacion: {
                    url: dominio.sv_cloud,
                    text: "¿Necesitas otro tipo de información?"
                },
                iravtr: {
                    url: dominio.sv_cloud,
                    text: "Ir al Home"
                },
                social: {
                    facebook: redes.facebook,
                    twitter: redes.twitter,
                    youtube: redes.youtube
                },
                links: {
                    condiciones: {
                        text: "Condiciones de uso vtr.com",
                        url: dominio.vtr_cloud + "productos/condiciones-uso"
                    },
                    privacidad: {
                        url: dominio.vtr_cloud + "productos/privacidad",
                        text: "Privacidad"
                    },
                    vtr: {
                        url: dominio.sv_cloud,
                        text: "VTR Comunicaciones SPA"
                    }
                }
            }
        }
    }
};

const redirect = {
    production: {
        vtr_com: { "normal": "https://vtr.com/", "cloud": "https://vtr.com/" },
        sucursal_virtual: { "normal": dominio.sv, "cloud": dominio.sv_cloud }
    },
    development: {
        vtr_com: { "normal": dominio.kepler, "cloud": dominio.kepler_cloud },
        sucursal_virtual: { "normal": dominio.kepler + "sucursalvirtual/index.html#/resumen", "cloud": dominio.kepler_cloud + "sucursalvirtual/index.html#/resumen" }
    },
    qa: {
        vtr_com: { "normal": dominio.kepler, "cloud": dominio.kepler_cloud },
        sucursal_virtual: { "normal": dominio.kepler + "sucursalvirtual/index.html#/resumen", "cloud": dominio.kepler_cloud + "sucursalvirtual/index.html#/resumen" }
    }
}

const touch = {
    vtr_com: "pago express",
    sucursal_virtual: "sucursal virtual",
    apps: "app",
    baf: "baf"
}

const billingLabel = {
    rut: "Rut: ",
    name: "Nombre: "
}

const minAmountPUFDevice = 21000;
Vue.mixin({
    data: function() {
        return {
            get accountConstans() {
                return accounts
            },
            get infoConstans() {
                return info
            },
            get customerConstans() {
                return customer
            },
            get invoiceConstans() {
                return invoice
            },
            get errorInvoiceConstans() {
                return errorInvoice
            }
        }
    }
});

export {
    accounts,
    info,
    customer,
    invoice,
    errorInvoice,
    homeUrl,
    redirect,
    varsFooterHeader,
    touch,
    billingLabel,
    errorBilling,
    notDue,
    recaptcha,
    minAmountPUFDevice
}
